import { combineSearchParams } from "../utils/urlUtils";
import axiosInstance from "./axios";
import { Family, FullProductData } from "./models/fullProductData.models";

const apiUrl = import.meta.env.VITE_BACKEND_API_URL;

export const fetchFullProductData = async (
  bearerToken: string,
  searchStrings: string[],
  page: number = 1
): Promise<{
  data: FullProductData[];
  isSynkkaData: boolean;
  synkkaFamily: Family;
}> => {
  try {
    const response = await axiosInstance.get(
      searchStrings?.length > 0
        ? `${apiUrl}/Products/fullproductdata${combineSearchParams(searchStrings)}&page=${page}`
        : `${apiUrl}/Products/fullproductdata?page=${page}`,
      {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      }
    );
    return {
      data: response.data,
      isSynkkaData: false,
      synkkaFamily: Family.product,
    };
  } catch (error) {
    console.error("Failed to fetch full product data:", error);
    throw error;
  }
};

export const fetchCompanyFullProductData = async (
  bearerToken: string,
  companyId: number,
  eans: string[],
  isEanSearch: boolean = false
): Promise<{
  data: FullProductData[];
  isSynkkaData: boolean;
  synkkaFamily: Family;
}> => {
  try {
    let response = await axiosInstance.get(
      `${apiUrl}/Products/${companyId}/fullproductdata${combineSearchParams(eans)}`,
      {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      }
    );

    // If response data is empty array, fetchFullProductData without companyId
    // This is a fallback to ensure we get product data even if the company-specific endpoint returns no results
    if (response.data?.length === 0 && isEanSearch) {
      const secondResult = await fetchFullProductData(bearerToken, eans);

      if (secondResult?.data?.length > 0) {
        return {
          data: secondResult.data,
          isSynkkaData: true,
          synkkaFamily: Family.product,
        };
      }
    }

    return {
      data: response.data,
      isSynkkaData: false,
      synkkaFamily: Family.product,
    };
  } catch (error) {
    console.error("Failed to fetch company full product data:", error);
    throw error;
  }
};
